module.exports = __webpack_public_path__ + "img/features_scoremaster_phone_mobile2.34809e02.jpg";